import { AppSession } from '@prisma/client'
import { Api } from '~/core/trpc'

type Props = {
  appSession: AppSession
}

export const useOnboarding = ({ appSession }: Props) => {
  const formConfiguration = Api.formConfiguration.findFirst.useQuery(
    {
      where: {
        appId: appSession?.appId,
        type: 'ONBOARDING',
      },
    },
    { enabled: !!appSession },
  )

  const formStatus = appSession?.statusOnboarding
  const isCorrupted = appSession?.statusOnboarding === 'CORRUPTED'
  const isPending = appSession?.statusOnboarding === 'PENDING'
  const isOnboarded = appSession?.statusOnboarding === 'DONE'
  const isSubmitted = appSession?.statusOnboarding === 'SUBMITTED'

  return {
    hasOnboarding: !!formConfiguration.data,
    formConfiguration: formConfiguration.data,
    formStatus,
    isCorrupted,
    isPending,
    isOnboarded,
    isSubmitted,
  }
}
